import React from 'react'
import PropTypes from 'prop-types'
import {Box, Divider, Grid, Stack, Image, useMultiStyleConfig} from '@chakra-ui/react'
import CustomLink from '../custom-link'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

const QuickLinks = ({quickLinksSchema}) => {
    const styles = useMultiStyleConfig('Footer')
    const {buildUrl} = useMultiSite()

    return (
        <Grid {...styles.iconsBenefitSection}>
            {quickLinksSchema.map((item, index) => {
                const isExternalUrl = !!item?.is_external_url
                const isLastItem = index === quickLinksSchema.length - 1
                const isSecondItem = index === 1
                // const isSvg = item?.icon?.content_type.includes('svg')

                return (
                    <React.Fragment key={index}>
                        <Stack {...styles.benefitStack}>
                            <Image
                                src={item?.icon?.url}
                                alt={item?.cta?.title}
                                {...styles.benefitIcons}
                            />
                            <Box>
                                <CustomLink
                                    isExternal={isExternalUrl}
                                    href={
                                        isExternalUrl ? item?.cta?.href : buildUrl(item?.cta?.href)
                                    }
                                    {...styles.benefitText}
                                >
                                    {item?.cta?.title}
                                </CustomLink>
                            </Box>
                        </Stack>
                        {!isLastItem && (
                            <Divider
                                orientation="vertical"
                                display={{
                                    base: isSecondItem ? 'none' : 'block',
                                    md: isSecondItem ? 'none' : 'block',
                                    lg: 'block',
                                }}
                                {...styles.dividerRule}
                            />
                        )}
                        {isSecondItem && (
                            <Divider
                                display={{base: 'block', lg: 'none'}}
                                gridColumn="1 / -1"
                                {...styles.dividerRule}
                            />
                        )}
                    </React.Fragment>
                )
            })}
        </Grid>
    )
}

QuickLinks.propTypes = {
    quickLinksSchema: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.shape({url: PropTypes.string, title: PropTypes.string}),
            cta: PropTypes.shape({href: PropTypes.string, title: PropTypes.string}),
            is_external_url: PropTypes.bool,
        }),
    ).isRequired,
}

export default QuickLinks
